import React, { useContext, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { CustomSelect, withTooltip } from 'components';
import { OptionType } from 'components/CustomSelect/types';
import { CompGroupsContext } from 'context';
import { gridShortDate } from 'utilities';
import { PreviousVersionsListProps } from './PreviousVersionsList.props';

const PreviousVersionsList = ({ cell, ...restProps }: PreviousVersionsListProps) => {
  const { onCommit, onRevert } = restProps;
  const { group } = useContext(CompGroupsContext);

  const getOptions = useMemo(() => {
    const tmpOptions: OptionType[] = [];

    if (!isEmpty(group?.versions)) {
      group?.versions?.forEach(version => {
        tmpOptions.push({
          label: `${gridShortDate(version.created_at)} | V-${version.version_number}`,
          value: version.id ?? '',
        });
      });
    }
    return tmpOptions.sort((a, b) => (b.value as number) - (a.value as number));
  }, [group?.versions]);

  return (
    <CustomSelect
      id="captable-list"
      options={getOptions}
      value={(cell?.value as { id: string })?.id || ''}
      onCommit={onCommit}
      onRevert={onRevert}
      onEmptyValue={''}
    />
  );
};

export default withTooltip(PreviousVersionsList);
